import type { DefaultRootState } from 'react-redux';

export default (state: DefaultRootState) => state.menu.leftBar.width || 64;
